<template>
  <div class="w-70 pr-12px mt-12px">
    <div class="half-graph-container">
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          border-bottom
          px-2
          pb-2
        "
      >
        <div class="dashboardAdmin-cards-head ml-2">
          Recently Selected Candidates
        </div>
        <div class="d-flex align-items-center justify-content-end mr-2 w-50">
          <div
            class="position-relative w-70"
            v-if="
              getRecentlyCand.length ||
              (!getRecentlyCand.length && searchQuery != '')
            "
          >
            <span>
              <img
                class="gm-search-pos"
                src="../../assets/img/search-bar-icon.svg"
                alt
              />
            </span>
            <b-form-input
              class="gm-search-input"
              type="search"
              v-model="searchQuery"
              debounce="500"
              placeholder="Search"
            ></b-form-input>
          </div>
          <div
            class="ml-4 pointer"
            v-if="roles.includes('GET_REPORT_RECRUITER')"
            @click="goTorecruiter()"
          >
            <img
              src="../../assets/New-imgs/landing-dashboard/redirect.svg"
              alt=""
            />
          </div>
        </div>
      </div>
      <b-overlay :show="showSpinner">
        <div class="rsel-main-table">
          <div
            class="rsel-table-head"
            v-if="
              (getRecentlyCand && getRecentlyCand.length) ||
              (!getRecentlyCand && getRecentlyCandlength && searchQuery != '')
            "
          >
            <div class="pl-4" :class="leadKey ? 'w-35' : 'w-40'">
              Candidate Name
              <template v-if="sortBy == 'candidateName'">
                <img
                  v-if="sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'candidateName'),
                      (sortOrder = 1);

                    getCandidates();
                  "
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'candidateName'),
                      (sortOrder = -1);

                    getCandidates();
                  "
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                class="pointer"
                v-else
                @click="
                  (sortBy = 'candidateName'),
                    (sortByValue = true),
                    (sortOrder = -1);

                  getCandidates();
                "
                src="../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div :class="leadKey ? 'w-25' : 'w-40'">
              Job Name
              <template v-if="sortBy == 'title'">
                <img
                  v-if="sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'title'),
                      (sortOrder = 1);

                    getCandidates();
                  "
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'title'),
                      (sortOrder = -1);

                    getCandidates();
                  "
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                class="pointer"
                v-else
                @click="
                  (sortBy = 'title'), (sortByValue = true), (sortOrder = -1);
                  getCandidates();
                "
                src="../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div class="w-25" v-if="leadKey">Recruiter Name</div>

            <div class="text-center" :class="leadKey ? 'w-15' : 'w-20'">
              Actions
            </div>
          </div>
          <div class="rsel-table-body">
            <div
              v-if="
                !showSpinner && getRecentlyCand.length == 0 && searchQuery != ''
              "
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
                mt-4
              "
            >
              <div>
                <img
                  src="../../assets/New-imgs/landing-dashboard/no-data-dashboard.svg"
                  alt=""
                />
              </div>
              <div
                v-if="searchQuery != 'Loader' && searchQuery != ''"
                class="mt-2 text-center access-font-color"
              >
                No matching results for
                <span class="access-font-color-b text-center text-break">
                  "{{ searchQuery }}"
                </span>
              </div>
              <div v-else class="mt-2 text-center access-font-color">
                No data found
              </div>
            </div>
            <div
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
                mt-4
              "
              v-else-if="
                !showSpinner && getRecentlyCand.length == 0 && searchQuery == ''
              "
            >
              <div>
                <img
                  class="mt-4"
                  src="../../assets/New-imgs/landing-dashboard/no-scheduleInterview.svg"
                  alt=""
                />
              </div>
              <div class="text-center access-font-color">
                There are no recently selected candidates
              </div>
            </div>
            <div v-else>
              <div
                v-for="(cand, index) in getRecentlyCand"
                :key="index"
                class="rsel-table-row"
              >
                <div
                  class="position-relative pl-4"
                  :class="leadKey ? 'w-35' : 'w-40'"
                >
                  <div class="rsel-grid-line"></div>
                  <div class="text-truncate pr-1">{{ cand.candidateName }}</div>
                </div>
                <div
                  class="text-truncate pr-2"
                  :class="leadKey ? 'w-25' : 'w-40'"
                >
                  {{ cand.title }}
                </div>
                <div class="w-25 text-truncate pr-2 pl-1" v-if="leadKey">
                  {{ projectUsers[cand.selectedBy].username }}
                </div>

                <div
                  class="d-flex justify-content-center"
                  :class="leadKey ? 'w-15' : 'w-20'"
                >
                  <img
                    v-b-tooltip.hover="'View'"
                    v-if="cand.candidateID != selectedCandidate.candidateID"
                    @click="viewCandidate(cand)"
                    class="pointer"
                    src="../../assets/talentpool/blueEye.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/talentpool/notviewicon.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
    <PreviewCandidateSidebar
      v-if="viewCandidateModal"
      :showModal="viewCandidateModal"
      :candidateID="selectedCandidate.candidateID"
      :customFieldsArray="customFieldsArray"
      :selectedCandidate="selectedCandidate"
      :showNote="false"
      :showActivate="false"
      @close-view-icon="closeViewIcon"
    />
  </div>
</template>

<script>
import {
  getRecentlySelectedCand,
  getCustomerFields,
} from "../../utils/apiFunctions.js";
import PreviewCandidateSidebar from "../../controllers/JD/modals/PreviewCandidateSidebar.vue";

import { mapGetters } from "vuex";

export default {
  props: {
    leadKey: Boolean,
  },
  components: {
    PreviewCandidateSidebar,
  },
  data() {
    return {
      sortByValue: false,
      showSpinner: false,
      searchQuery: "",
      sortBy: "selectedAt",
      getRecentlyCand: [],
      selectedCandidate: {},
      sortOrder: -1,
      viewCandidateModal: false,
    };
  },
  created() {
    this.getCandidates();
    this.getCustomField();
    // if(this.$route.query.history && !this.previewModal){
    //   this.viewCandidate(this.storedData.candidate);
    // }
  },

  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.showSpinner = true;
          this.getCandidates();
        }
      }
    },
  },
  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("userVUEX", {
      projectUsers: "getProjectUsers",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      storedData: "getSelectedCandidate",
    }),
  },
  methods: {
    goTorecruiter() {
      this.$router.push({
        name: "RecruiterReport",
        query: {
          status: "dashboard",
        },
      });
    },
    closeViewIcon() {
      this.viewCandidateModal = false;
      this.selectedCandidate = {}; // Update selectedCandidate based on the event
    },
    viewCandidate(cand) {
      this.selectedCandidate = cand;

      this.viewCandidateModal = true;
    },
    async getCustomField() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getCandidates() {
      try {
        let payload = {
          searchQuery: this.searchQuery,
          sortBy: this.sortBy,
          order: this.sortOrder,
          lead: this.leadKey,
        };
        const res = await getRecentlySelectedCand(payload);
        if (res.status == 200) {
          this.showSpinner = false;
          this.getRecentlyCand = res.data.data.data;
        } else if (res.status == 500) {
          this.showSpinner = false;
        }
      } catch (e) {
        console.error(e);
        this.showSpinner = false;
      }
    },
  },
};
</script>

<style lang="postcss" scoped></style>
